import { Scope } from '@unform/core'

import { FormGroup, Input, InputHidden, Label } from '~/components/unform'
import { capitalizeWords } from '~/helpers/capitalize-words'

import AlertBrandsPureComponent from '../../../AlertBrands/PureComponent'

type OffsiteDestinationUrlProps = {
  publisherId: string
  publisherName: string
  config: PublisherConfiguration | null
  // Single-brand-only (no multi-varejista, no multi-brand in this
  // experience — confirmed by the author): lets the parent track whether
  // a default destination URL exists, to require it when some media has
  // none of its own (FR-022l).
  required?: boolean
  onChange?(value: string): void
}

const OffsiteDestinationUrl = ({
  publisherId,
  publisherName,
  config,
  required,
  onChange
}: OffsiteDestinationUrlProps) => {
  const has_brands = !!config?.configuration.brands

  return (
    <div>
      {publisherName && (
        <p className="mb-0">
          <strong>{capitalizeWords(publisherName)}</strong>
        </p>
      )}

      {has_brands && (
        <header className="mb-2">
          <AlertBrandsPureComponent
            publisherBrands={config.configuration.brands}
          />
        </header>
      )}

      {!has_brands && (
        <Input
          name="destination_url"
          id={`destination_url-${publisherId}`}
          required={required}
          onChange={({ value }: OnChangeInputData) => onChange?.(value)}
        />
      )}

      {!!has_brands && (
        <Scope path="destinations">
          {config.configuration.brands.map((item, index) => (
            <Scope path={`${index}`} key={`${publisherId}-${item.code}`}>
              <FormGroup className="mb-2">
                <Label text={item.name} htmlFor="url" />
                <Input name="url" id="url" />
                <InputHidden
                  id="brand"
                  name="brand"
                  value={item.code}
                  readOnly
                />
                <InputHidden
                  id="publisher_id"
                  name="publisher_id"
                  value={publisherId}
                  readOnly
                />
              </FormGroup>
            </Scope>
          ))}
        </Scope>
      )}
    </div>
  )
}

export default OffsiteDestinationUrl
